"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _2025_aktiveKommunenummerjson = /*#__PURE__*/ _interop_require_default(require("./2025_aktiveKommunenummer.json"));
var _2025_aktiveLandkoderjson = /*#__PURE__*/ _interop_require_default(require("./2025_aktiveLandkoder.json"));
var _2025_aktiveLandkoder_eoesjson = /*#__PURE__*/ _interop_require_default(require("./2025_aktiveLandkoder_eoes.json"));
var _2025_formuesobjekttypeUpersonligSkattepliktigjson = /*#__PURE__*/ _interop_require_default(require("./2025_formuesobjekttypeUpersonligSkattepliktig.json"));
var _2025_prissoneOgKostnadssjablongPerKommunenummerVedFormuesfastsettingAvSkogeiendomjson = /*#__PURE__*/ _interop_require_default(require("./2025_prissoneOgKostnadssjablongPerKommunenummerVedFormuesfastsettingAvSkogeiendom.json"));
var _2025_satserIFormuesOgInntektsskattjson = /*#__PURE__*/ _interop_require_default(require("./2025_satserIFormuesOgInntektsskatt.json"));
var _2025_summertSkattegrunnlagForVisningjson = /*#__PURE__*/ _interop_require_default(require("./2025_summertSkattegrunnlagForVisning.json"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    "2025_aktiveKommunenummer": _2025_aktiveKommunenummerjson.default,
    "2025_aktiveLandkoder": _2025_aktiveLandkoderjson.default,
    "2025_aktiveLandkoder_eoes": _2025_aktiveLandkoder_eoesjson.default,
    "2025_formuesobjekttypeUpersonligSkattepliktig": _2025_formuesobjekttypeUpersonligSkattepliktigjson.default,
    "2025_prissoneOgKostnadssjablongPerKommunenummerVedFormuesfastsettingAvSkogeiendom": _2025_prissoneOgKostnadssjablongPerKommunenummerVedFormuesfastsettingAvSkogeiendomjson.default,
    "2025_satserIFormuesOgInntektsskatt": _2025_satserIFormuesOgInntektsskattjson.default,
    "2025_summertSkattegrunnlagForVisning": _2025_summertSkattegrunnlagForVisningjson.default
};
